/**
 * Announcement Bar Trust — horizontale Swiper fuer Desktop und Mobile getrennt.
 * Benoetigt `swiper-bundle.min.js` (wie im Theme-Layout geladen).
 */
(function () {
  'use strict';

  var SELECTOR_BAR = '.js-announcement-bar-trust';

  function queryBars(root) {
    if (!root) {
      return document.querySelectorAll(SELECTOR_BAR);
    }
    if (root.matches && root.matches(SELECTOR_BAR)) {
      return [root];
    }
    return root.querySelectorAll(SELECTOR_BAR);
  }

  function initAnnouncementBarTrustSlider(bar, slider, options) {
    if (!slider || slider.dataset.swiperInit === '1') return;

    var slideCount = slider.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      .matches;
    var delay = Number(bar.dataset.delay) || 5000;
    var speed = Number(bar.dataset.speed) || 450;
    var pauseOnHover = bar.dataset.pauseOnHover === 'true';

    slider.dataset.swiperInit = '1';

    /* global Swiper */
    new Swiper(slider, {
      direction: 'horizontal',
      slidesPerView: 1,
      loop: options.loop,
      speed: speed,
      allowTouchMove: false,
      autoplay: prefersReducedMotion
        ? false
        : {
            delay: delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover,
          },
    });
  }

  function initAnnouncementBarTrust(root) {
    if (typeof Swiper === 'undefined') return;

    var bars = queryBars(root);
    if (!bars || !bars.length) return;

    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.dataset.announcementBarTrustInit === '1') return;

      var desktopSlider = bar.querySelector('.js-announcement-bar-trust-swiper-desktop');
      var mobileSlider = bar.querySelector('.js-announcement-bar-trust-swiper-mobile');

      if (!desktopSlider && !mobileSlider) return;

      bar.dataset.announcementBarTrustInit = '1';

      initAnnouncementBarTrustSlider(bar, desktopSlider, { loop: true });
      initAnnouncementBarTrustSlider(bar, mobileSlider, { loop: false });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector(SELECTOR_BAR)) return;
    initAnnouncementBarTrust();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncementBarTrust(event.target);
  });
})();

/**
 * Gravur: Zeichenzähler unter der Textarea (__C__ / __M__ aus Locale), leer = ausgeblendet.
 */
(function () {
  'use strict';

  function updateGravurCounter(textarea) {
    var counterId =
      textarea.getAttribute('data-gravur-counter-id') ||
      textarea.dataset.gravurCounterId;
    if (!counterId) return;
    var el = document.getElementById(counterId);
    if (!el) return;
    var tpl =
      textarea.getAttribute('data-gravur-counter-template') ||
      textarea.dataset.gravurCounterTemplate ||
      '';
    if (tpl.indexOf('__C__') === -1 || tpl.indexOf('__M__') === -1) {
      tpl = '__C__ of __M__ characters used';
    }
    var max =
      textarea.getAttribute('data-gravur-max') ||
      textarea.dataset.gravurMax ||
      String(textarea.getAttribute('maxlength') || '');
    var n = textarea.value.length;

    if (n === 0) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.textContent = '';
      return;
    }

    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    var text = tpl.split('__C__').join(String(n)).split('__M__').join(String(max));
    el.textContent = text;
  }

  function bindGravurCounters(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var list = scope.querySelectorAll('textarea.product-gravur__textarea');
    Array.prototype.forEach.call(list, function (ta) {
      if (ta.getAttribute('data-gravur-counter-bound') === '1') return;
      ta.setAttribute('data-gravur-counter-bound', '1');
      ta.addEventListener('input', function () {
        updateGravurCounter(ta);
      });
      updateGravurCounter(ta);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindGravurCounters();
  });

  document.addEventListener('shopify:section:load', function (event) {
    bindGravurCounters(event.target);
  });
})();
